import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { DashboardService } from 'src/app/services/dashboard.service';
import { DropboxService } from 'src/app/services/dropbox.service';
import { ClientService } from '../../services/client.service';
import { ContextService } from '../../services/context.service';

@Component({
	selector: 'app-configure',
	templateUrl: './configure.component.html',
	styleUrls: ['./configure.component.css']
})
export class ConfigureComponent implements OnInit {
	@Output() emitExit = new EventEmitter<any>();
	@Input() folders = [];
	@Input() templates = [];

	@ViewChild('selectCommitmentFilename1') selectCommitmentFilename1: ElementRef;
	@ViewChild('selectCommitmentFilename2') selectCommitmentFilename2: ElementRef;
	@ViewChild('selectCommitmentFilename2') selectCommitmentFilename3: ElementRef;

	loading = true;
	loadingUsers = false;
	loadingLaunchDashboard = false;

	originalClientDetailProcore: any;
	clientDetailProcore: any;
	projectConfigs: any = {};

	showCommunicationExpanded = false;
	showWorkflowExpanded = false;
	showFilenameExpanded = false;
	showRequestExpanded = false;
	showRequestTemplatesExpanded = false;
	showStorageExpanded = false;
	showSecurityExpanded = false;
	showUsersExpanded = false;

	primeContractFilename1Value;
	primeContractFilename2Value;
	primeContractFilename3Value;
	commitmentFilename1Value;
	commitmentFilename2Value;
	commitmentFilename3Value;
	changeOrderFilename1Value;
	changeOrderFilename2Value;
	changeOrderFilename3Value;

	folderOptions = [];

	users = [];
	userToDelete: any;

	constructor(
		private clientService: ClientService,
		private dashboardService: DashboardService,
		private dropboxService: DropboxService,
		public contextService: ContextService,
	) { }

	ngOnInit() {
		this.clientDetailProcore = this.contextService.clientDetailProcore;
		this.originalClientDetailProcore = JSON.parse(JSON.stringify(this.clientDetailProcore));

		for (const folder of this.folders) {
			this.populateFolderOptions(folder, 0);
		}

		this.primeContractFilename1Value = this.returnFilenameLabel(this.clientDetailProcore.primeContractFilename1, 'primeContract');
		this.primeContractFilename2Value = this.returnFilenameLabel(this.clientDetailProcore.primeContractFilename2, 'primeContract');
		this.primeContractFilename3Value = this.returnFilenameLabel(this.clientDetailProcore.primeContractFilename3, 'primeContract');
		this.commitmentFilename1Value = this.returnFilenameLabel(this.clientDetailProcore.commitmentFilename1, 'commitment');
		this.commitmentFilename2Value = this.returnFilenameLabel(this.clientDetailProcore.commitmentFilename2, 'commitment');
		this.commitmentFilename3Value = this.returnFilenameLabel(this.clientDetailProcore.commitmentFilename3, 'commitment');
		this.changeOrderFilename1Value = this.returnFilenameLabel(this.clientDetailProcore.changeOrderFilename1, 'changeOrder');
		this.changeOrderFilename2Value = this.returnFilenameLabel(this.clientDetailProcore.changeOrderFilename2, 'changeOrder');
		this.changeOrderFilename3Value = this.returnFilenameLabel(this.clientDetailProcore.changeOrderFilename3, 'changeOrder');

		this.setProjectConfigs();

		if (this.templates.length == 0) {
			this.retrieveTemplates();
		}

		this.loading = false;
	}

	returnFilenameLabel(value, type) {
		if (value == 'contractNumber' && type == 'changeOrder') {
			return 'Change Order #';
		} else if (value == 'contractNumber' && type !== 'changeOrder') {
			return 'Contract #';
		} else if (value == 'contractCompany') {
			return 'Contract Company'
		} else if (value == 'title') {
			return 'Title'
		} else if (value == 'projectName') {
			return 'Project Name'
		} else if (value == 'contractOwner') {
			return 'Owner / Client'
		} else {
			return '';
		}
	}

	expandUsers() {
		if (this.showUsersExpanded) {
			// Already expanded, collapse it
			this.showUsersExpanded = false;
			this.users = [];
		} else {
			// Collapsed, expand it
			this.showUsersExpanded = true;
			this.getUsers();
		}
	}

	getUsers() {
		this.loadingUsers = true;
		this.clientService.getUsers(this.contextService.procoreContextObject.context.company_id, this.contextService.procoreUserInfo.email, this.contextService.procoreUserInfo.procoreUserId, this.contextService.procoreIsSandbox).subscribe((response: any) => {
			this.users = response;
			this.loadingUsers = false;
		});
	}

	deleteUser(user) {
		this.userToDelete = user;
		this.clientService.deleteUser(this.contextService.procoreContextObject.context.company_id, this.contextService.procoreUserInfo.email, this.contextService.procoreUserInfo.procoreUserId, user.userName, this.contextService.procoreIsSandbox).subscribe((response: any) => {
			if (response == true) {
				let item = this.users.find(d => d.userName === user.userName);
				if (item) {
					this.users.splice(this.users.indexOf(item), 1);
				}
			}
			this.userToDelete = null;
		});
	}

	setProjectConfigs() {
		this.setDefaultProjectConfigs();
		for (const config of this.clientDetailProcore.projectConfigs) {
			if (config.configName === 'allowDefaultLocationOverride') {
				this.projectConfigs[config.configName] = config.configValue === 'true';
			} else {
				this.projectConfigs[config.configName] = config.configValue;
			}
		}
	}

	setDefaultProjectConfigs() {
		this.projectConfigs = {
			allowDefaultLocationOverride: false,
			primeContractStorage: 'default',
			primeContractCoStorage: 'default',
			primeContractPcoStorage: 'default',
			subcontractStorage: 'default',
			subcontractCoStorage: 'default',
			subcontractPcoStorage: 'default',
			purchaseOrderStorage: 'default',
			purchaseOrderCoStorage: 'default',
			purchaseOrderPcoStorage: 'default'
		};
	}

	cancelConfigurations() {
		console.log(this.originalClientDetailProcore);
		this.contextService.clientDetailProcore = JSON.parse(JSON.stringify(this.originalClientDetailProcore));
		this.clientDetailProcore = JSON.parse(JSON.stringify(this.originalClientDetailProcore));

		this.setProjectConfigs();

		this.emitExit.emit(false);
	}

	updateConfigurations() {
		this.loading = true;
		this.clientService.updateClientDetailProcore(this.clientDetailProcore, false).subscribe(() => {
			this.clientService.updateProcoreProjectConfigs(this.projectConfigs, this.clientDetailProcore.clientId, this.contextService.procoreContextObject.context.project_id)
				.subscribe(() => {
					for (let config of this.clientDetailProcore.projectConfigs) {
						if (config.configName == 'allowDefaultLocationOverride') {
							config.configValue = this.projectConfigs.allowDefaultLocationOverride;
						} else if (config.configName == 'primeContractCoStorage') {
							config.configValue = this.projectConfigs.primeContractCoStorage;
						} else if (config.configName == 'primeContractPcoStorage') {
							config.configValue = this.projectConfigs.primeContractPcoStorage;
						} else if (config.configName == 'primeContractStorage') {
							config.configValue = this.projectConfigs.primeContractStorage;
						} else if (config.configName == 'purchaseOrderCoStorage') {
							config.configValue = this.projectConfigs.purchaseOrderCoStorage;
						} else if (config.configName == 'purchaseOrderPcoStorage') {
							config.configValue = this.projectConfigs.purchaseOrderPcoStorage;
						} else if (config.configName == 'purchaseOrderStorage') {
							config.configValue = this.projectConfigs.purchaseOrderStorage;
						} else if (config.configName == 'subcontractCoStorage') {
							config.configValue = this.projectConfigs.subcontractCoStorage;
						} else if (config.configName == 'subcontractPcoStorage') {
							config.configValue = this.projectConfigs.subcontractPcoStorage;
						} else if (config.configName == 'subcontractStorage') {
							config.configValue = this.projectConfigs.subcontractStorage;
						}
					}
					this.loading = false;
					this.emitExit.emit(true);
				},
					(error) => {
						this.loading = false;
						this.emitExit.emit(false);
					}
				);
		});
	}

	populateFolderOptions(folder: any, depth: number) {
		this.folderOptions.push({
			id: folder.id,
			name: '-'.repeat(depth) + folder.name
		});
		if (folder.children) {
			for (const child of folder.children) {
				this.populateFolderOptions(child, depth + 1);
			}
		}
	}

	launchSignatures() {
		this.loadingLaunchDashboard = true;
		this.dashboardService.getDashboardToken(this.contextService.procoreContextObject.context.company_id, this.contextService.procoreContextObject.context.project_id, this.contextService.procoreUserInfo.email, this.contextService.procoreUserInfo.procoreUserId, this.contextService.procoreIsSandbox, 'DBS for Procore')
			.subscribe((response: any) => {
				this.loadingLaunchDashboard = false;
				window.open('/signatures?uuid=' + response, '_blank');
			});
	}

	changePrimeContractFilename1(event) {
		const selectElement = event.target as HTMLSelectElement;
		this.primeContractFilename1Value = selectElement.options[selectElement.selectedIndex].text;
	}

	changePrimeContractFilename2(event) {
		const selectElement = event.target as HTMLSelectElement;
		this.primeContractFilename2Value = selectElement.options[selectElement.selectedIndex].text;
	}

	changePrimeContractFilename3(event) {
		const selectElement = event.target as HTMLSelectElement;
		this.primeContractFilename3Value = selectElement.options[selectElement.selectedIndex].text;
	}

	changeCommitmentFilename1(event) {
		const selectElement = event.target as HTMLSelectElement;
		this.commitmentFilename1Value = selectElement.options[selectElement.selectedIndex].text;
	}

	changeCommitmentFilename2(event) {
		const selectElement = event.target as HTMLSelectElement;
		this.commitmentFilename2Value = selectElement.options[selectElement.selectedIndex].text;
	}

	changeCommitmentFilename3(event) {
		const selectElement = event.target as HTMLSelectElement;
		this.commitmentFilename3Value = selectElement.options[selectElement.selectedIndex].text;
	}

	changeChangeOrderFilename1(event) {
		const selectElement = event.target as HTMLSelectElement;
		this.changeOrderFilename1Value = selectElement.options[selectElement.selectedIndex].text;
	}

	changeChangeOrderFilename2(event) {
		const selectElement = event.target as HTMLSelectElement;
		this.changeOrderFilename2Value = selectElement.options[selectElement.selectedIndex].text;
	}

	changeChangeOrderFilename3(event) {
		const selectElement = event.target as HTMLSelectElement;
		this.changeOrderFilename3Value = selectElement.options[selectElement.selectedIndex].text;
	}

	changeEnableDropboxSignTemplateOverlays(event) {
		const inputElement = event.target as HTMLInputElement;
		if (inputElement.value == 'on') {
			this.retrieveTemplates();
		}
	}

	clearDefaultRequestTemplateCommitmentPurchaseOrder() {
		this.clientDetailProcore.defaultRequestTemplateCommitmentPurchaseOrder = '';
	}

	clearDefaultRequestTemplateCommitmentPurchaseOrderChangeOrder() {
		this.clientDetailProcore.defaultRequestTemplateCommitmentPurchaseOrderChangeOrder = '';
	}

	clearDefaultRequestTemplateCommitmentSubcontract() {
		this.clientDetailProcore.defaultRequestTemplateCommitmentSubcontract = '';
	}

	clearDefaultRequestTemplateCommitmentSubcontractChangeOrder() {
		this.clientDetailProcore.defaultRequestTemplateCommitmentSubcontractChangeOrder = '';
	}

	clearDefaultRequestTemplatePrimeContract() {
		this.clientDetailProcore.defaultRequestTemplatePrimeContract = '';
	}

	clearDefaultRequestTemplatePrimeContractChangeOrder() {
		this.clientDetailProcore.defaultRequestTemplatePrimeContractChangeOrder = '';
	}

	retrieveTemplates() {
		this.dropboxService.getTemplates(this.contextService.procoreContextObject.context.company_id, this.contextService.signatureCount?.dropboxSignUsername).subscribe((result) => {
			this.templates = result;
			this.templates.sort((a, b) => a.title.localeCompare(b.title));
		});
	}
}
